import { BCMSCurrency, BCMSRecord, DisabledPrompt, useBCMSContext, useRoute } from "@bcm-dev/bcms-vite";
import { FormContainer, FormRowView } from "components/shared";
import { FormButtonRow } from "components/shared/containers/FormContainer";
import { UIAmountInput, UIButton, UICheckbox } from "components/ui";
import Classes, { Account, UserAccount } from "model";

import "./styles.css";

export default function BelowThresholdContent(props) {
    const context = useBCMSContext();
    const navigate = useRoute();

    BCMSRecord.globalControllerFor(Classes, context);

    const account = Account.initAll()[0];
    const balanceThreshold = BCMSCurrency.init(100);

    const onCancel = evt => navigate("/advancedAlerts/currentAlerts");

    return (
        <div className="below-threshold-content">
            <p className="page-subtitle">Account Balance Below Threshold</p>

            <FormContainer className="small-form-width">
                <FormRowView>
                    <div className="flex-container flex-vertical account-details">
                        <p className="account-name">{ account.nickname }</p>
                        <p className="account-number">{ account.number }</p>
                        <p className="account-amount">{ account.currentBalance.format() }</p>
                    </div>
                </FormRowView>

                <FormRowView text="Amount *">
                    <UIAmountInput value={ balanceThreshold.format().slice(1) } />
                </FormRowView>

                <FormRowView text="Recipients *">
                    <div className="flex-container flex-vertical">
                        { UserAccount.initAll().map(({ emailAddress }) => <UICheckbox label={ emailAddress } />, []) }
                    </div>
                </FormRowView>

                <FormButtonRow>
                    <UIButton className="secondary-button" text="Cancel" onClick={ onCancel } />
                    
                    <DisabledPrompt>
                        <UIButton className="primary-button" text="Update" />
                        <UIButton className="primary-button" text="Delete" />
                    </DisabledPrompt>
                </FormButtonRow>
            </FormContainer>
        </div>
    );
}